interface FilterBarProps {
  region: string;
  year: string;
  actor: string;
  regions: string[];
  years: number[];
  actors: string[];
  active: boolean;
  open: boolean;
  onToggle: () => void;
  onRegionChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onActorChange: (value: string) => void;
  onReset: () => void;
}

export default function FilterBar({
  region,
  year,
  actor,
  regions,
  years,
  actors,
  active,
  open,
  onToggle,
  onRegionChange,
  onYearChange,
  onActorChange,
  onReset,
}: FilterBarProps) {
  const sections = [
    {
      title: "地区",
      icon: "ri-earth-line",
      value: region,
      options: regions.map((item) => ({ value: item, label: item })),
      onChange: onRegionChange,
    },
    {
      title: "上映年份",
      icon: "ri-calendar-line",
      value: year,
      options: years.map((item) => ({ value: String(item), label: `${item}` })),
      onChange: onYearChange,
    },
    {
      title: "演员标签",
      icon: "ri-user-star-line",
      value: actor,
      options: actors.map((item) => ({ value: item, label: item })),
      onChange: onActorChange,
    },
  ];

  return (
    <aside className="w-full lg:w-[260px] shrink-0">
      <button
        type="button"
        onClick={onToggle}
        className="lg:hidden w-full h-11 px-4 rounded-md border border-background-300 bg-background-100 flex items-center justify-between text-sm text-foreground-800 cursor-pointer"
      >
        <span className="flex items-center gap-2">
          <i className="ri-filter-3-line text-accent-700" />
          筛选条件
          {active && (
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 inline-block" />
          )}
        </span>
        <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base`} />
      </button>

      <div
        className={`${
          open ? "block" : "hidden"
        } lg:block mt-3 lg:mt-0 rounded-lg border border-background-200 bg-background-100 overflow-hidden`}
      >
        <div className="hidden lg:flex items-center justify-between px-4 h-12 border-b border-background-200">
          <span className="text-sm font-medium text-foreground-900 flex items-center gap-2">
            <i className="ri-filter-3-line text-accent-700" />
            筛选条件
          </span>
          <button
            type="button"
            onClick={onReset}
            className="text-[12px] text-foreground-500 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            重置
          </button>
        </div>
        <div className="p-4 flex flex-col gap-5">
          {sections.map((section) => (
            <div key={section.title}>
              <p className="text-[12px] text-foreground-500 mb-2.5 flex items-center gap-1.5">
                <i className={`${section.icon} text-[13px] text-foreground-400`} />
                {section.title}
              </p>
              <div className="flex flex-wrap gap-1.5">
                <button
                  type="button"
                  onClick={() => section.onChange("")}
                  className={`h-7 px-2.5 rounded-md text-[12px] whitespace-nowrap transition-colors cursor-pointer ${
                    section.value === ""
                      ? "bg-primary-900 text-background-50"
                      : "bg-background-50 border border-background-200 text-foreground-600 hover:border-accent-300"
                  }`}
                >
                  全部
                </button>
                {section.options.map((option) => (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() => section.onChange(option.value)}
                    className={`h-7 px-2.5 rounded-md text-[12px] whitespace-nowrap transition-colors cursor-pointer ${
                      section.value === option.value
                        ? "bg-primary-900 text-background-50"
                        : "bg-background-50 border border-background-200 text-foreground-600 hover:border-accent-300"
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={onReset}
            className="lg:hidden w-full h-9 rounded-md border border-background-300 text-[13px] text-foreground-700 hover:bg-background-50 transition-colors cursor-pointer"
          >
            重置全部筛选
          </button>
        </div>
      </div>

      <div className="hidden lg:block mt-4 rounded-lg border border-background-200 p-4">
        <p className="text-[12px] text-foreground-500 mb-2">筛选说明</p>
        <p className="text-[12px] leading-relaxed text-foreground-600">
          地区、年份与演员标签可以组合使用，选中后列表会即时刷新，结果数量与分页也会同步更新。
        </p>
      </div>
    </aside>
  );
}